import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { PerformanceReport } from './data/api';

interface ReportHeaderProps {
  report: PerformanceReport;
  accountCount: number;
}

export function ReportHeader({ report, accountCount }: ReportHeaderProps): ReactNode {
  const [from, to] = report.dateRange;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography component="h1" sx={{ fontSize: 22, fontWeight: 600, color: 'text.primary' }}>
        Creative Performance
      </Typography>
      <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
        {accountCount === 0
          ? 'All accounts'
          : `${accountCount} account${accountCount === 1 ? '' : 's'}`}{' '}
        · leading KPI {report.kpi.label} · {from} – {to}
      </Typography>
      {report.inFlight && (
        <Box>
          <Chip
            size="small"
            color="warning"
            label={`Range runs past settled data — cut to ${to}`}
          />
        </Box>
      )}
    </Box>
  );
}
